import _ from 'lodash';
// This template inside the report url is replaced with the producer code
const PRODUCER_CODE_TEMPLATE = '%%PRODUCER-CODE%%';

export default ['$state', '$scope', '$injector', ($state, $scope, $injector) => {
    let reports = [];
    const CONFIGURATION_PROVIDER = 'AGENT_REPORTS';
    if ($injector.has(CONFIGURATION_PROVIDER)) {
        // Only load the configuration in portals that provide it
        reports = $injector.get(CONFIGURATION_PROVIDER);
    }

    if (!Array.isArray(reports) || reports.length === 0) {
        return;
    }

    $scope.producerCode = {
        code: ''
    }; // Initial value

    $scope.select = (report) => {
        reports.forEach((_report) => {
            _report.active = false;
        });
        report.active = true;
        const producerCode = $scope.producerCode.code === 'all' ? '' : $scope.producerCode.code;
        $scope.reportUrl = report.reportUrl !== null ? report.reportUrl.replace(PRODUCER_CODE_TEMPLATE, encodeURIComponent(producerCode)) : null;
        $scope.reportType = report.type;
    };
    $scope.select(reports[0]);

    $scope.updateSelected = () => $scope.select(_.find(reports, 'active'));
    $scope.$watch('producerCode', () => {
        $scope.updateSelected();
    });

    if (reports.length > 1) {
        // Only render tiles if there's a choice of reports
        $scope.reports = reports;
    }
}];